export type Language = 'en' | 'fr' | 'ar' | 'ru' | 'zh'

export interface Brief613Translations {
  nav: {
    title: string
    welcome: string
    logout: string
    managerLogin: string
  }
  login: {
    title: string
    subtitle: string
    username: string
    password: string
    usernamePlaceholder: string
    passwordPlaceholder: string
    loginButton: string
    loggingIn: string
    noAccount: string
    register: string
    error: string
    invalidCredentials: string
    required: string
  }
  register: {
    title: string
    subtitle: string
    username: string
    email: string
    password: string
    confirmPassword: string
    companyName: string
    usernamePlaceholder: string
    emailPlaceholder: string
    passwordPlaceholder: string
    confirmPasswordPlaceholder: string
    companyNamePlaceholder: string
    registerButton: string
    registering: string
    haveAccount: string
    login: string
    allFieldsRequired: string
    passwordTooShort: string
    passwordsDontMatch: string
    error: string
  }
  managerLogin: {
    title: string
    subtitle: string
    username: string
    password: string
    usernamePlaceholder: string
    passwordPlaceholder: string
    loginButton: string
    loggingIn: string
    error: string
    invalidCredentials: string
  }
  common: {
    loading: string
    error: string
    success: string
    cancel: string
    save: string
    delete: string
    edit: string
    add: string
    close: string
    confirm: string
    yes: string
    no: string
    search: string
    filter: string
    actions: string
  }
  dashboard: {
    client: {
      title: string
      createBrief: string
      myBriefs: string
      noBriefs: string
      createFirstBrief: string
    }
    admin: {
      title: string
      briefs: string
      users: string
      managers: string
      notifications: string
    }
    manager: {
      title: string
      assignedBriefs: string
      noBriefs: string
    }
  }
    brief: {
      create: string
      edit: string
      view: string
      delete: string
      title: string
      status: string
      manager: string
      createdAt: string
      updatedAt: string
      form: {
        title: string
        selectType: string
        selectTypeDesc: string
        changeType: string
        briefType: string
        event: string
        digitalMarketing: string
        print: string
        custom: string
        eventDesc: string
        digitalDesc: string
        printDesc: string
        customDesc: string
        selectSections: string
        selectSectionsDesc: string
        campaignTitle: string
        campaignTitlePlaceholder: string
        objective: string
        objectiveRequired: string
        targetAudience: string
        targetAudienceRequired: string
        targetAudiencePlaceholder: string
        desiredReaction: string
        desiredReactionRequired: string
        selectReaction: string
        keyMessage: string
        keyMessageRequired: string
        keyMessagePlaceholder: string
        tone: string
        toneRequired: string
        selectTone: string
        deliverables: string
        deliverablesRequired: string
        addUrl: string
        inspirationUrls: string
        inspirationUrlsDesc: string
        brandAssets: string
        brandAssetsPlaceholder: string
        brandAssetsDesc: string
        constraints: string
        constraintsPlaceholder: string
        budget: string
        budgetPlaceholder: string
        deadline: string
        deadlineRequired: string
        approvalContactName: string
        approvalContactNameRequired: string
        approvalContactEmail: string
        approvalContactEmailRequired: string
        additionalNotes: string
        additionalNotesPlaceholder: string
        submit: string
        submitting: string
        cancel: string
        eventInfo: string
        eventInfoDesc: string
        numberOfParticipants: string
        numberOfParticipantsPlaceholder: string
        totalParticipants: string
        totalParticipantsDesc: string
        eventLocations: string
        eventLocationsDesc: string
        location: string
        country: string
        selectCountry: string
        address: string
        addressPlaceholder: string
        dateStart: string
        dateEnd: string
        timeStart: string
        timeEnd: string
        participantsPerLocation: string
        addLocation: string
        eventDate: string
        eventTime: string
        eventTimeDesc: string
        sections: {
          campaignBasics: string
          targetAudience: string
          messaging: string
          deliverables: string
          eventInfo: string
          digitalMarketing: string
          printMaterials: string
          inspiration: string
          brandAssets: string
          constraints: string
          budget: string
          contact: string
          notes: string
        }
        specifyOther: string
        allFieldsRequired: string
        eventFieldsRequired: string
        selectBriefType: string
      }
      fields: {
        objective: string
        targetAudience: string
        desiredReaction: string
        keyMessage: string
        tone: string
        deliverables: string
        deadline: string
        approvalContactName: string
        approvalContactEmail: string
        campaignTitle: string
        inspirationUrls: string
        brandAssets: string
        constraints: string
        budget: string
        additionalNotes: string
      }
      statuses: {
        submitted: string
        inReview: string
        approved: string
        inProgress: string
        completed: string
        rejected: string
      }
    }
  manager: {
    title: string
    add: string
    edit: string
    delete: string
    name: string
    email: string
    phone: string
    username: string
    password: string
    isActive: string
    briefCount: string
    cannotDelete: string
    deleteConfirm: string
  }
  user: {
    title: string
    username: string
    email: string
    companyName: string
    role: string
    delete: string
    deleteConfirm: string
  }
}

export const brief613Translations: Record<Language, Brief613Translations> = {
  en: {
    nav: {
      title: 'Brief 613',
      welcome: 'Welcome,',
      logout: 'Logout',
      managerLogin: 'Manager Login',
    },
    login: {
      title: 'Login',
      subtitle: 'Welcome back to Brief 613',
      username: 'Username or Email',
      password: 'Password',
      usernamePlaceholder: 'Enter your username or email',
      passwordPlaceholder: 'Enter your password',
      loginButton: 'Login',
      loggingIn: 'Logging in...',
      noAccount: "Don't have an account?",
      register: 'Register',
      error: 'An error occurred',
      invalidCredentials: 'Invalid username or password',
      required: 'Username and password are required',
    },
    register: {
      title: 'Register',
      subtitle: 'Create your Brief 613 account',
      username: 'Username',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      companyName: 'Company Name',
      usernamePlaceholder: 'Enter your username',
      emailPlaceholder: 'Enter your email',
      passwordPlaceholder: 'Enter your password',
      confirmPasswordPlaceholder: 'Confirm your password',
      companyNamePlaceholder: 'Enter your company name',
      registerButton: 'Register',
      registering: 'Registering...',
      haveAccount: 'Already have an account?',
      login: 'Login',
      allFieldsRequired: 'All fields are required',
      passwordTooShort: 'Password must be at least 6 characters long',
      passwordsDontMatch: 'Passwords do not match',
      error: 'An error occurred',
    },
    managerLogin: {
      title: 'Manager Login',
      subtitle: 'Access your manager dashboard',
      username: 'Username',
      password: 'Password',
      usernamePlaceholder: 'Enter your username',
      passwordPlaceholder: 'Enter your password',
      loginButton: 'Login',
      loggingIn: 'Logging in...',
      error: 'An error occurred',
      invalidCredentials: 'Invalid username or password',
    },
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      close: 'Close',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      search: 'Search',
      filter: 'Filter',
      actions: 'Actions',
    },
    dashboard: {
      client: {
        title: 'Client Dashboard',
        createBrief: 'Create Brief',
        myBriefs: 'My Briefs',
        noBriefs: 'No briefs yet',
        createFirstBrief: 'Create Your First Brief',
      },
      admin: {
        title: 'Admin Dashboard',
        briefs: 'Briefs',
        users: 'Users',
        managers: 'Managers',
        notifications: 'Notifications',
      },
      manager: {
        title: 'Manager Dashboard',
        assignedBriefs: 'Assigned Briefs',
        noBriefs: 'No briefs assigned',
      },
    },
    brief: {
      create: 'Create Brief',
      edit: 'Edit Brief',
      view: 'View Brief',
      delete: 'Delete Brief',
      title: 'Brief Title',
      status: 'Status',
      manager: 'Manager',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      form: {
        title: 'Create Creative Brief',
        selectType: 'Select Brief Type',
        selectTypeDesc: 'Choose the type of brief you want to create',
        changeType: 'Change Type',
        briefType: 'Brief Type',
        event: 'Event',
        digitalMarketing: 'Digital Marketing Campaign',
        print: 'Print',
        custom: 'Custom',
        eventDesc: 'For event planning, conferences, workshops, and physical gatherings. Includes event-specific fields like locations, dates, and participant count.',
        digitalDesc: 'For online campaigns, social media, websites, digital ads, and online content. Focused on digital channels and platforms.',
        printDesc: 'For print materials, brochures, posters, packaging, point of sale materials, and other physical printed items.',
        customDesc: 'For mixed campaigns or when you need everything. Choose which sections to include from Event, Digital Marketing, and Print based on your needs.',
        selectSections: 'Select Sections to Include',
        selectSectionsDesc: 'Choose which sections you want to include in your brief',
        campaignTitle: 'Campaign Name / Title',
        campaignTitlePlaceholder: 'e.g., Summer 2024 Product Launch',
        objective: 'Objective',
        objectiveRequired: 'Objective *',
        targetAudience: 'Target Audience',
        targetAudienceRequired: 'Target Audience *',
        targetAudiencePlaceholder: 'Who is the primary audience for this campaign?',
        desiredReaction: 'Desired Reaction',
        desiredReactionRequired: 'Desired Reaction *',
        selectReaction: 'Select reaction',
        keyMessage: 'Key Message',
        keyMessageRequired: 'Key Message *',
        keyMessagePlaceholder: 'What\'s the one key message you want to communicate?',
        tone: 'Tone or Style',
        toneRequired: 'Tone or Style *',
        selectTone: 'Select tone',
        deliverables: 'Deliverables & Channels',
        deliverablesRequired: 'Deliverables & Channels *',
        addUrl: 'Add URL',
        inspirationUrls: 'Inspiration URLs',
        inspirationUrlsDesc: 'Add URLs for inspiration, reference campaigns, or examples',
        brandAssets: 'Brand Assets & Guidelines',
        brandAssetsPlaceholder: 'Links to brand guidelines, logos, color palettes, fonts, style guides, or other brand assets',
        brandAssetsDesc: 'Enter one URL per line',
        constraints: 'Constraints & Limitations',
        constraintsPlaceholder: 'Things to avoid, restrictions, legal requirements, mandatory elements (logos, disclaimers), or any limitations',
        budget: 'Budget',
        budgetPlaceholder: 'e.g., $10,000 - $15,000 or Budget range',
        deadline: 'Deadline',
        deadlineRequired: 'Deadline *',
        approvalContactName: 'Approval Contact Name',
        approvalContactNameRequired: 'Approval Contact Name *',
        approvalContactEmail: 'Approval Contact Email',
        approvalContactEmailRequired: 'Approval Contact Email *',
        additionalNotes: 'Additional Notes',
        additionalNotesPlaceholder: 'Any additional information, context, or special instructions for the creative team',
        submit: 'Submit Brief',
        submitting: 'Submitting...',
        cancel: 'Cancel',
        eventInfo: 'Event Information (Optional)',
        eventInfoDesc: 'Fill this section if your brief is for an event',
        numberOfParticipants: 'Total Number of Participants',
        numberOfParticipantsPlaceholder: 'Auto-calculated from all locations',
        totalParticipants: 'Total Participants',
        totalParticipantsDesc: 'Sum of participants from all locations',
        eventLocations: 'Event Locations',
        eventLocationsDesc: 'Add one or more locations with details for each',
        location: 'Location',
        country: 'Country',
        selectCountry: 'Select country',
        address: 'Address',
        addressPlaceholder: 'Full address',
        dateStart: 'Start Date',
        dateEnd: 'End Date',
        timeStart: 'Start Time',
        timeEnd: 'End Time',
        participantsPerLocation: 'Number of Participants',
        addLocation: 'Add Another Location',
        eventDate: 'Event Date (Optional)',
        eventTime: 'Event Time (Optional)',
        eventTimeDesc: 'Time of day for the event',
        sections: {
          campaignBasics: 'Campaign Basics (Objective, Title)',
          targetAudience: 'Target Audience',
          messaging: 'Messaging (Key Message, Tone, Reaction)',
          deliverables: 'Deliverables & Channels',
          eventInfo: 'Event Information',
          digitalMarketing: 'Digital Marketing Specific',
          printMaterials: 'Print Materials',
          inspiration: 'Inspiration URLs',
          brandAssets: 'Brand Assets & Guidelines',
          constraints: 'Constraints & Limitations',
          budget: 'Budget',
          contact: 'Contact Information',
          notes: 'Additional Notes',
        },
        specifyOther: 'Specify other',
        allFieldsRequired: 'Please fill in all required fields',
        eventFieldsRequired: 'Please fill in event-specific required fields (number of participants and at least one location)',
        selectBriefType: 'Please select a brief type',
      },
      fields: {
        objective: 'Objective',
        targetAudience: 'Target Audience',
        desiredReaction: 'Desired Reaction',
        keyMessage: 'Key Message',
        tone: 'Tone',
        deliverables: 'Deliverables',
        deadline: 'Deadline',
        approvalContactName: 'Approval Contact Name',
        approvalContactEmail: 'Approval Contact Email',
        campaignTitle: 'Campaign Title',
        inspirationUrls: 'Inspiration URLs',
        brandAssets: 'Brand Assets',
        constraints: 'Constraints',
        budget: 'Budget',
        additionalNotes: 'Additional Notes',
      },
      statuses: {
        submitted: 'Submitted',
        inReview: 'In Review',
        approved: 'Approved',
        inProgress: 'In Progress',
        completed: 'Completed',
        rejected: 'Rejected',
      },
    },
    manager: {
      title: 'Project Managers',
      add: 'Add Manager',
      edit: 'Edit Manager',
      delete: 'Delete Manager',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      username: 'Username',
      password: 'Password',
      isActive: 'Active',
      briefCount: 'briefs',
      cannotDelete: 'Cannot delete: has assigned briefs',
      deleteConfirm: 'Are you sure you want to delete',
    },
    user: {
      title: 'Users',
      username: 'Username',
      email: 'Email',
      companyName: 'Company Name',
      role: 'Role',
      delete: 'Delete',
      deleteConfirm: 'Are you sure you want to delete',
    },
  },
  fr: {
    nav: {
      title: 'Brief 613',
      welcome: 'Bienvenue,',
      logout: 'Déconnexion',
      managerLogin: 'Connexion Manager',
    },
    login: {
      title: 'Connexion',
      subtitle: 'Bon retour sur Brief 613',
      username: "Nom d'utilisateur ou Email",
      password: 'Mot de passe',
      usernamePlaceholder: "Entrez votre nom d'utilisateur ou email",
      passwordPlaceholder: 'Entrez votre mot de passe',
      loginButton: 'Se connecter',
      loggingIn: 'Connexion...',
      noAccount: "Vous n'avez pas de compte?",
      register: "S'inscrire",
      error: 'Une erreur est survenue',
      invalidCredentials: "Nom d'utilisateur ou mot de passe invalide",
      required: "Le nom d'utilisateur et le mot de passe sont requis",
    },
    register: {
      title: "S'inscrire",
      subtitle: 'Créez votre compte Brief 613',
      username: "Nom d'utilisateur",
      email: 'Email',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      companyName: "Nom de l'entreprise",
      usernamePlaceholder: "Entrez votre nom d'utilisateur",
      emailPlaceholder: 'Entrez votre email',
      passwordPlaceholder: 'Entrez votre mot de passe',
      confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
      companyNamePlaceholder: "Entrez le nom de votre entreprise",
      registerButton: "S'inscrire",
      registering: 'Inscription...',
      haveAccount: 'Vous avez déjà un compte?',
      login: 'Se connecter',
      allFieldsRequired: 'Tous les champs sont requis',
      passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
      passwordsDontMatch: 'Les mots de passe ne correspondent pas',
      error: 'Une erreur est survenue',
    },
    managerLogin: {
      title: 'Connexion Manager',
      subtitle: 'Accédez à votre tableau de bord manager',
      username: "Nom d'utilisateur",
      password: 'Mot de passe',
      usernamePlaceholder: "Entrez votre nom d'utilisateur",
      passwordPlaceholder: 'Entrez votre mot de passe',
      loginButton: 'Se connecter',
      loggingIn: 'Connexion...',
      error: 'Une erreur est survenue',
      invalidCredentials: "Nom d'utilisateur ou mot de passe invalide",
    },
    common: {
      loading: 'Chargement...',
      error: 'Erreur',
      success: 'Succès',
      cancel: 'Annuler',
      save: 'Enregistrer',
      delete: 'Supprimer',
      edit: 'Modifier',
      add: 'Ajouter',
      close: 'Fermer',
      confirm: 'Confirmer',
      yes: 'Oui',
      no: 'Non',
      search: 'Rechercher',
      filter: 'Filtrer',
      actions: 'Actions',
    },
    dashboard: {
      client: {
        title: 'Tableau de bord client',
        createBrief: 'Créer un brief',
        myBriefs: 'Mes briefs',
        noBriefs: 'Aucun brief pour le moment',
        createFirstBrief: 'Créer votre premier brief',
      },
      admin: {
        title: 'Tableau de bord admin',
        briefs: 'Briefs',
        users: 'Utilisateurs',
        managers: 'Managers',
        notifications: 'Notifications',
      },
      manager: {
        title: 'Tableau de bord manager',
        assignedBriefs: 'Briefs assignés',
        noBriefs: 'Aucun brief assigné',
      },
    },
    brief: {
      create: 'Créer un brief',
      edit: 'Modifier le brief',
      view: 'Voir le brief',
      delete: 'Supprimer le brief',
      title: 'Titre du brief',
      status: 'Statut',
      manager: 'Manager',
      createdAt: 'Créé le',
      updatedAt: 'Mis à jour le',
      form: {
        title: 'Créer un brief créatif',
        selectType: 'Sélectionner le type de brief',
        selectTypeDesc: 'Choisissez le type de brief que vous souhaitez créer',
        changeType: 'Changer le type',
        briefType: 'Type de brief',
        event: 'Événement',
        digitalMarketing: 'Campagne marketing digital',
        print: 'Impression',
        custom: 'Personnalisé',
        eventDesc: 'Pour la planification d\'événements, conférences, ateliers et rassemblements physiques. Inclut des champs spécifiques aux événements comme les lieux, dates et nombre de participants.',
        digitalDesc: 'Pour les campagnes en ligne, réseaux sociaux, sites web, publicités numériques et contenu en ligne. Axé sur les canaux et plateformes numériques.',
        printDesc: 'Pour les matériaux imprimés, brochures, affiches, emballages, matériaux de point de vente et autres articles imprimés physiques.',
        customDesc: 'Pour les campagnes mixtes ou lorsque vous avez besoin de tout. Choisissez les sections à inclure parmi Événement, Marketing digital et Impression selon vos besoins.',
        selectSections: 'Sélectionner les sections à inclure',
        selectSectionsDesc: 'Choisissez les sections que vous souhaitez inclure dans votre brief',
        campaignTitle: 'Nom / Titre de la campagne',
        campaignTitlePlaceholder: 'ex: Lancement produit été 2024',
        objective: 'Objectif',
        objectiveRequired: 'Objectif *',
        targetAudience: 'Public cible',
        targetAudienceRequired: 'Public cible *',
        targetAudiencePlaceholder: 'Quel est le public principal de cette campagne?',
        desiredReaction: 'Réaction souhaitée',
        desiredReactionRequired: 'Réaction souhaitée *',
        selectReaction: 'Sélectionner une réaction',
        keyMessage: 'Message clé',
        keyMessageRequired: 'Message clé *',
        keyMessagePlaceholder: 'Quel est le message clé que vous souhaitez communiquer?',
        tone: 'Ton ou style',
        toneRequired: 'Ton ou style *',
        selectTone: 'Sélectionner un ton',
        deliverables: 'Livrables et canaux',
        deliverablesRequired: 'Livrables et canaux *',
        addUrl: 'Ajouter une URL',
        inspirationUrls: 'URLs d\'inspiration',
        inspirationUrlsDesc: 'Ajoutez des URLs pour l\'inspiration, des campagnes de référence ou des exemples',
        brandAssets: 'Actifs de marque et directives',
        brandAssetsPlaceholder: 'Liens vers les directives de marque, logos, palettes de couleurs, polices, guides de style ou autres actifs de marque',
        brandAssetsDesc: 'Entrez une URL par ligne',
        constraints: 'Contraintes et limitations',
        constraintsPlaceholder: 'Choses à éviter, restrictions, exigences légales, éléments obligatoires (logos, avertissements) ou toute limitation',
        budget: 'Budget',
        budgetPlaceholder: 'ex: 10 000 € - 15 000 € ou fourchette budgétaire',
        deadline: 'Date limite',
        deadlineRequired: 'Date limite *',
        approvalContactName: 'Nom du contact approbateur',
        approvalContactNameRequired: 'Nom du contact approbateur *',
        approvalContactEmail: 'Email du contact approbateur',
        approvalContactEmailRequired: 'Email du contact approbateur *',
        additionalNotes: 'Notes supplémentaires',
        additionalNotesPlaceholder: 'Toute information supplémentaire, contexte ou instructions spéciales pour l\'équipe créative',
        submit: 'Soumettre le brief',
        submitting: 'Soumission...',
        cancel: 'Annuler',
        eventInfo: 'Informations sur l\'événement (Optionnel)',
        eventInfoDesc: 'Remplissez cette section si votre brief concerne un événement',
        numberOfParticipants: 'Nombre total de participants',
        numberOfParticipantsPlaceholder: 'Calculé automatiquement à partir de tous les lieux',
        totalParticipants: 'Total des participants',
        totalParticipantsDesc: 'Somme des participants de tous les lieux',
        eventLocations: 'Lieux de l\'événement',
        eventLocationsDesc: 'Ajoutez un ou plusieurs lieux avec les détails pour chacun',
        location: 'Lieu',
        country: 'Pays',
        selectCountry: 'Sélectionner un pays',
        address: 'Adresse',
        addressPlaceholder: 'Adresse complète',
        dateStart: 'Date de début',
        dateEnd: 'Date de fin',
        timeStart: 'Heure de début',
        timeEnd: 'Heure de fin',
        participantsPerLocation: 'Nombre de participants',
        addLocation: 'Ajouter un autre lieu',
        eventDate: 'Date de l\'événement (Optionnel)',
        eventTime: 'Heure de l\'événement (Optionnel)',
        eventTimeDesc: 'Heure de la journée pour l\'événement',
        sections: {
          campaignBasics: 'Bases de la campagne (Objectif, Titre)',
          targetAudience: 'Public cible',
          messaging: 'Messagerie (Message clé, Ton, Réaction)',
          deliverables: 'Livrables et canaux',
          eventInfo: 'Informations sur l\'événement',
          digitalMarketing: 'Marketing digital spécifique',
          printMaterials: 'Matériaux imprimés',
          inspiration: 'URLs d\'inspiration',
          brandAssets: 'Actifs de marque et directives',
          constraints: 'Contraintes et limitations',
          budget: 'Budget',
          contact: 'Informations de contact',
          notes: 'Notes supplémentaires',
        },
        specifyOther: 'Spécifier autre',
        allFieldsRequired: 'Veuillez remplir tous les champs requis',
        eventFieldsRequired: 'Veuillez remplir les champs spécifiques à l\'événement (nombre de participants et au moins un lieu)',
        selectBriefType: 'Veuillez sélectionner un type de brief',
      },
      fields: {
        objective: 'Objectif',
        targetAudience: 'Public cible',
        desiredReaction: 'Réaction souhaitée',
        keyMessage: 'Message clé',
        tone: 'Ton',
        deliverables: 'Livrables',
        deadline: 'Date limite',
        approvalContactName: 'Nom du contact approbateur',
        approvalContactEmail: 'Email du contact approbateur',
        campaignTitle: 'Titre de la campagne',
        inspirationUrls: 'URLs d\'inspiration',
        brandAssets: 'Actifs de marque',
        constraints: 'Contraintes',
        budget: 'Budget',
        additionalNotes: 'Notes supplémentaires',
      },
      statuses: {
        submitted: 'Soumis',
        inReview: 'En révision',
        approved: 'Approuvé',
        inProgress: 'En cours',
        completed: 'Terminé',
        rejected: 'Rejeté',
      },
    },
    manager: {
      title: 'Chefs de projet',
      add: 'Ajouter un manager',
      edit: 'Modifier le manager',
      delete: 'Supprimer le manager',
      name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      username: "Nom d'utilisateur",
      password: 'Mot de passe',
      isActive: 'Actif',
      briefCount: 'briefs',
      cannotDelete: 'Impossible de supprimer: a des briefs assignés',
      deleteConfirm: 'Êtes-vous sûr de vouloir supprimer',
    },
    user: {
      title: 'Utilisateurs',
      username: "Nom d'utilisateur",
      email: 'Email',
      companyName: "Nom de l'entreprise",
      role: 'Rôle',
      delete: 'Supprimer',
      deleteConfirm: 'Êtes-vous sûr de vouloir supprimer',
    },
  },
  ar: {
    nav: {
      title: 'بريف 613',
      welcome: 'مرحباً،',
      logout: 'تسجيل الخروج',
      managerLogin: 'تسجيل دخول المدير',
    },
    login: {
      title: 'تسجيل الدخول',
      subtitle: 'مرحباً بعودتك إلى بريف 613',
      username: 'اسم المستخدم أو البريد الإلكتروني',
      password: 'كلمة المرور',
      usernamePlaceholder: 'أدخل اسم المستخدم أو البريد الإلكتروني',
      passwordPlaceholder: 'أدخل كلمة المرور',
      loginButton: 'تسجيل الدخول',
      loggingIn: 'جاري تسجيل الدخول...',
      noAccount: 'ليس لديك حساب؟',
      register: 'التسجيل',
      error: 'حدث خطأ',
      invalidCredentials: 'اسم المستخدم أو كلمة المرور غير صحيحة',
      required: 'اسم المستخدم وكلمة المرور مطلوبان',
    },
    register: {
      title: 'التسجيل',
      subtitle: 'أنشئ حسابك في بريف 613',
      username: 'اسم المستخدم',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
      companyName: 'اسم الشركة',
      usernamePlaceholder: 'أدخل اسم المستخدم',
      emailPlaceholder: 'أدخل البريد الإلكتروني',
      passwordPlaceholder: 'أدخل كلمة المرور',
      confirmPasswordPlaceholder: 'أكد كلمة المرور',
      companyNamePlaceholder: 'أدخل اسم الشركة',
      registerButton: 'التسجيل',
      registering: 'جاري التسجيل...',
      haveAccount: 'لديك حساب بالفعل؟',
      login: 'تسجيل الدخول',
      allFieldsRequired: 'جميع الحقول مطلوبة',
      passwordTooShort: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
      passwordsDontMatch: 'كلمات المرور غير متطابقة',
      error: 'حدث خطأ',
    },
    managerLogin: {
      title: 'تسجيل دخول المدير',
      subtitle: 'الوصول إلى لوحة تحكم المدير',
      username: 'اسم المستخدم',
      password: 'كلمة المرور',
      usernamePlaceholder: 'أدخل اسم المستخدم',
      passwordPlaceholder: 'أدخل كلمة المرور',
      loginButton: 'تسجيل الدخول',
      loggingIn: 'جاري تسجيل الدخول...',
      error: 'حدث خطأ',
      invalidCredentials: 'اسم المستخدم أو كلمة المرور غير صحيحة',
    },
    common: {
      loading: 'جاري التحميل...',
      error: 'خطأ',
      success: 'نجح',
      cancel: 'إلغاء',
      save: 'حفظ',
      delete: 'حذف',
      edit: 'تعديل',
      add: 'إضافة',
      close: 'إغلاق',
      confirm: 'تأكيد',
      yes: 'نعم',
      no: 'لا',
      search: 'بحث',
      filter: 'تصفية',
      actions: 'الإجراءات',
    },
    dashboard: {
      client: {
        title: 'لوحة تحكم العميل',
        createBrief: 'إنشاء بريف',
        myBriefs: 'بريفاتي',
        noBriefs: 'لا توجد بريفات بعد',
        createFirstBrief: 'أنشئ بريفك الأول',
      },
      admin: {
        title: 'لوحة تحكم المسؤول',
        briefs: 'البريفات',
        users: 'المستخدمون',
        managers: 'المديرون',
        notifications: 'الإشعارات',
      },
      manager: {
        title: 'لوحة تحكم المدير',
        assignedBriefs: 'البريفات المخصصة',
        noBriefs: 'لا توجد بريفات مخصصة',
      },
    },
    brief: {
      create: 'إنشاء بريف',
      edit: 'تعديل البريف',
      view: 'عرض البريف',
      delete: 'حذف البريف',
      title: 'عنوان البريف',
      status: 'الحالة',
      manager: 'المدير',
      createdAt: 'تم الإنشاء في',
      updatedAt: 'تم التحديث في',
      form: {
        title: 'إنشاء بريف إبداعي',
        selectType: 'اختر نوع البريف',
        selectTypeDesc: 'اختر نوع البريف الذي تريد إنشاءه',
        changeType: 'تغيير النوع',
        briefType: 'نوع البريف',
        event: 'حدث',
        digitalMarketing: 'حملة تسويق رقمي',
        print: 'طباعة',
        custom: 'مخصص',
        eventDesc: 'لتخطيط الأحداث والمؤتمرات وورش العمل والتجمعات الفعلية. يتضمن حقولًا خاصة بالأحداث مثل المواقع والتواريخ وعدد المشاركين.',
        digitalDesc: 'للحملات عبر الإنترنت ووسائل التواصل الاجتماعي والمواقع الإلكترونية والإعلانات الرقمية والمحتوى عبر الإنترنت. يركز على القنوات والمنصات الرقمية.',
        printDesc: 'للمواد المطبوعة والكتيبات والملصقات والتغليف ومواد نقطة البيع وغيرها من العناصر المطبوعة الفعلية.',
        customDesc: 'للحملات المختلطة أو عندما تحتاج إلى كل شيء. اختر الأقسام التي تريد تضمينها من الحدث والتسويق الرقمي والطباعة حسب احتياجاتك.',
        selectSections: 'اختر الأقسام المطلوب تضمينها',
        selectSectionsDesc: 'اختر الأقسام التي تريد تضمينها في بريفك',
        campaignTitle: 'اسم / عنوان الحملة',
        campaignTitlePlaceholder: 'مثال: إطلاق منتج صيف 2024',
        objective: 'الهدف',
        objectiveRequired: 'الهدف *',
        targetAudience: 'الجمهور المستهدف',
        targetAudienceRequired: 'الجمهور المستهدف *',
        targetAudiencePlaceholder: 'من هو الجمهور الأساسي لهذه الحملة؟',
        desiredReaction: 'رد الفعل المطلوب',
        desiredReactionRequired: 'رد الفعل المطلوب *',
        selectReaction: 'اختر رد الفعل',
        keyMessage: 'الرسالة الرئيسية',
        keyMessageRequired: 'الرسالة الرئيسية *',
        keyMessagePlaceholder: 'ما هي الرسالة الرئيسية التي تريد توصيلها؟',
        tone: 'النبرة أو الأسلوب',
        toneRequired: 'النبرة أو الأسلوب *',
        selectTone: 'اختر النبرة',
        deliverables: 'المخرجات والقنوات',
        deliverablesRequired: 'المخرجات والقنوات *',
        addUrl: 'إضافة رابط',
        inspirationUrls: 'روابط الإلهام',
        inspirationUrlsDesc: 'أضف روابط للإلهام أو حملات مرجعية أو أمثلة',
        brandAssets: 'أصول العلامة التجارية والإرشادات',
        brandAssetsPlaceholder: 'روابط لإرشادات العلامة التجارية والشعارات وألوان العلامة التجارية والخطوط وأدلة الأنماط أو أصول العلامة التجارية الأخرى',
        brandAssetsDesc: 'أدخل رابطًا واحدًا في كل سطر',
        constraints: 'القيود والحدود',
        constraintsPlaceholder: 'الأشياء التي يجب تجنبها والقيود والمتطلبات القانونية والعناصر الإلزامية (الشعارات، التنبيهات) أو أي قيود',
        budget: 'الميزانية',
        budgetPlaceholder: 'مثال: 10,000 - 15,000 دولار أو نطاق الميزانية',
        deadline: 'الموعد النهائي',
        deadlineRequired: 'الموعد النهائي *',
        approvalContactName: 'اسم جهة الاتصال للموافقة',
        approvalContactNameRequired: 'اسم جهة الاتصال للموافقة *',
        approvalContactEmail: 'البريد الإلكتروني لجهة الاتصال للموافقة',
        approvalContactEmailRequired: 'البريد الإلكتروني لجهة الاتصال للموافقة *',
        additionalNotes: 'ملاحظات إضافية',
        additionalNotesPlaceholder: 'أي معلومات إضافية أو سياق أو تعليمات خاصة لفريق الإبداع',
        submit: 'إرسال البريف',
        submitting: 'جاري الإرسال...',
        cancel: 'إلغاء',
        eventInfo: 'معلومات الحدث (اختياري)',
        eventInfoDesc: 'املأ هذا القسم إذا كان بريفك يتعلق بحدث',
        numberOfParticipants: 'إجمالي عدد المشاركين',
        numberOfParticipantsPlaceholder: 'محسوب تلقائيًا من جميع المواقع',
        totalParticipants: 'إجمالي المشاركين',
        totalParticipantsDesc: 'مجموع المشاركين من جميع المواقع',
        eventLocations: 'مواقع الحدث',
        eventLocationsDesc: 'أضف موقعًا واحدًا أو أكثر مع التفاصيل لكل موقع',
        location: 'الموقع',
        country: 'البلد',
        selectCountry: 'اختر البلد',
        address: 'العنوان',
        addressPlaceholder: 'العنوان الكامل',
        dateStart: 'تاريخ البدء',
        dateEnd: 'تاريخ الانتهاء',
        timeStart: 'وقت البدء',
        timeEnd: 'وقت الانتهاء',
        participantsPerLocation: 'عدد المشاركين',
        addLocation: 'إضافة موقع آخر',
        eventDate: 'تاريخ الحدث (اختياري)',
        eventTime: 'وقت الحدث (اختياري)',
        eventTimeDesc: 'وقت اليوم للحدث',
        sections: {
          campaignBasics: 'أساسيات الحملة (الهدف، العنوان)',
          targetAudience: 'الجمهور المستهدف',
          messaging: 'الرسائل (الرسالة الرئيسية، النبرة، رد الفعل)',
          deliverables: 'المخرجات والقنوات',
          eventInfo: 'معلومات الحدث',
          digitalMarketing: 'التسويق الرقمي المحدد',
          printMaterials: 'المواد المطبوعة',
          inspiration: 'روابط الإلهام',
          brandAssets: 'أصول العلامة التجارية والإرشادات',
          constraints: 'القيود والحدود',
          budget: 'الميزانية',
          contact: 'معلومات الاتصال',
          notes: 'ملاحظات إضافية',
        },
        specifyOther: 'تحديد آخر',
        allFieldsRequired: 'يرجى ملء جميع الحقول المطلوبة',
        eventFieldsRequired: 'يرجى ملء الحقول الخاصة بالحدث (عدد المشاركين وموقع واحد على الأقل)',
        selectBriefType: 'يرجى اختيار نوع البريف',
      },
      fields: {
        objective: 'الهدف',
        targetAudience: 'الجمهور المستهدف',
        desiredReaction: 'رد الفعل المطلوب',
        keyMessage: 'الرسالة الرئيسية',
        tone: 'النبرة',
        deliverables: 'المخرجات',
        deadline: 'الموعد النهائي',
        approvalContactName: 'اسم جهة الاتصال للموافقة',
        approvalContactEmail: 'البريد الإلكتروني لجهة الاتصال للموافقة',
        campaignTitle: 'عنوان الحملة',
        inspirationUrls: 'روابط الإلهام',
        brandAssets: 'أصول العلامة التجارية',
        constraints: 'القيود',
        budget: 'الميزانية',
        additionalNotes: 'ملاحظات إضافية',
      },
      statuses: {
        submitted: 'تم الإرسال',
        inReview: 'قيد المراجعة',
        approved: 'تم الموافقة',
        inProgress: 'قيد التنفيذ',
        completed: 'مكتمل',
        rejected: 'مرفوض',
      },
    },
    manager: {
      title: 'مديرو المشاريع',
      add: 'إضافة مدير',
      edit: 'تعديل المدير',
      delete: 'حذف المدير',
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      username: 'اسم المستخدم',
      password: 'كلمة المرور',
      isActive: 'نشط',
      briefCount: 'بريفات',
      cannotDelete: 'لا يمكن الحذف: لديه بريفات مخصصة',
      deleteConfirm: 'هل أنت متأكد من حذف',
    },
    user: {
      title: 'المستخدمون',
      username: 'اسم المستخدم',
      email: 'البريد الإلكتروني',
      companyName: 'اسم الشركة',
      role: 'الدور',
      delete: 'حذف',
      deleteConfirm: 'هل أنت متأكد من حذف',
    },
  },
  ru: {
    nav: {
      title: 'Бриф 613',
      welcome: 'Добро пожаловать,',
      logout: 'Выйти',
      managerLogin: 'Вход менеджера',
    },
    login: {
      title: 'Вход',
      subtitle: 'Добро пожаловать обратно в Бриф 613',
      username: 'Имя пользователя или Email',
      password: 'Пароль',
      usernamePlaceholder: 'Введите имя пользователя или email',
      passwordPlaceholder: 'Введите пароль',
      loginButton: 'Войти',
      loggingIn: 'Вход...',
      noAccount: 'Нет аккаунта?',
      register: 'Регистрация',
      error: 'Произошла ошибка',
      invalidCredentials: 'Неверное имя пользователя или пароль',
      required: 'Имя пользователя и пароль обязательны',
    },
    register: {
      title: 'Регистрация',
      subtitle: 'Создайте свой аккаунт Бриф 613',
      username: 'Имя пользователя',
      email: 'Email',
      password: 'Пароль',
      confirmPassword: 'Подтвердите пароль',
      companyName: 'Название компании',
      usernamePlaceholder: 'Введите имя пользователя',
      emailPlaceholder: 'Введите email',
      passwordPlaceholder: 'Введите пароль',
      confirmPasswordPlaceholder: 'Подтвердите пароль',
      companyNamePlaceholder: 'Введите название компании',
      registerButton: 'Зарегистрироваться',
      registering: 'Регистрация...',
      haveAccount: 'Уже есть аккаунт?',
      login: 'Войти',
      allFieldsRequired: 'Все поля обязательны',
      passwordTooShort: 'Пароль должен содержать не менее 6 символов',
      passwordsDontMatch: 'Пароли не совпадают',
      error: 'Произошла ошибка',
    },
    managerLogin: {
      title: 'Вход менеджера',
      subtitle: 'Доступ к панели управления менеджера',
      username: 'Имя пользователя',
      password: 'Пароль',
      usernamePlaceholder: 'Введите имя пользователя',
      passwordPlaceholder: 'Введите пароль',
      loginButton: 'Войти',
      loggingIn: 'Вход...',
      error: 'Произошла ошибка',
      invalidCredentials: 'Неверное имя пользователя или пароль',
    },
    common: {
      loading: 'Загрузка...',
      error: 'Ошибка',
      success: 'Успешно',
      cancel: 'Отмена',
      save: 'Сохранить',
      delete: 'Удалить',
      edit: 'Редактировать',
      add: 'Добавить',
      close: 'Закрыть',
      confirm: 'Подтвердить',
      yes: 'Да',
      no: 'Нет',
      search: 'Поиск',
      filter: 'Фильтр',
      actions: 'Действия',
    },
    dashboard: {
      client: {
        title: 'Панель клиента',
        createBrief: 'Создать бриф',
        myBriefs: 'Мои брифы',
        noBriefs: 'Пока нет брифов',
        createFirstBrief: 'Создайте свой первый бриф',
      },
      admin: {
        title: 'Панель администратора',
        briefs: 'Брифы',
        users: 'Пользователи',
        managers: 'Менеджеры',
        notifications: 'Уведомления',
      },
      manager: {
        title: 'Панель менеджера',
        assignedBriefs: 'Назначенные брифы',
        noBriefs: 'Нет назначенных брифов',
      },
    },
    brief: {
      create: 'Создать бриф',
      edit: 'Редактировать бриф',
      view: 'Просмотреть бриф',
      delete: 'Удалить бриф',
      title: 'Название брифа',
      status: 'Статус',
      manager: 'Менеджер',
      createdAt: 'Создан',
      updatedAt: 'Обновлен',
      form: {
        title: 'Создать креативный бриф',
        selectType: 'Выберите тип брифа',
        selectTypeDesc: 'Выберите тип брифа, который вы хотите создать',
        changeType: 'Изменить тип',
        briefType: 'Тип брифа',
        event: 'Событие',
        digitalMarketing: 'Цифровая маркетинговая кампания',
        print: 'Печать',
        custom: 'Пользовательский',
        eventDesc: 'Для планирования мероприятий, конференций, семинаров и физических встреч. Включает поля, специфичные для событий, такие как места, даты и количество участников.',
        digitalDesc: 'Для онлайн-кампаний, социальных сетей, веб-сайтов, цифровой рекламы и онлайн-контента. Сфокусирован на цифровых каналах и платформах.',
        printDesc: 'Для печатных материалов, брошюр, плакатов, упаковки, материалов точки продажи и других физических печатных изделий.',
        customDesc: 'Для смешанных кампаний или когда вам нужно все. Выберите, какие разделы включить из События, Цифрового маркетинга и Печати в зависимости от ваших потребностей.',
        selectSections: 'Выберите разделы для включения',
        selectSectionsDesc: 'Выберите разделы, которые вы хотите включить в свой бриф',
        campaignTitle: 'Название / Заголовок кампании',
        campaignTitlePlaceholder: 'например, Запуск продукта лето 2024',
        objective: 'Цель',
        objectiveRequired: 'Цель *',
        targetAudience: 'Целевая аудитория',
        targetAudienceRequired: 'Целевая аудитория *',
        targetAudiencePlaceholder: 'Кто является основной аудиторией этой кампании?',
        desiredReaction: 'Желаемая реакция',
        desiredReactionRequired: 'Желаемая реакция *',
        selectReaction: 'Выберите реакцию',
        keyMessage: 'Ключевое сообщение',
        keyMessageRequired: 'Ключевое сообщение *',
        keyMessagePlaceholder: 'Какое ключевое сообщение вы хотите передать?',
        tone: 'Тон или стиль',
        toneRequired: 'Тон или стиль *',
        selectTone: 'Выберите тон',
        deliverables: 'Результаты и каналы',
        deliverablesRequired: 'Результаты и каналы *',
        addUrl: 'Добавить URL',
        inspirationUrls: 'URL вдохновения',
        inspirationUrlsDesc: 'Добавьте URL для вдохновения, референсных кампаний или примеров',
        brandAssets: 'Активы бренда и руководящие принципы',
        brandAssetsPlaceholder: 'Ссылки на руководящие принципы бренда, логотипы, цветовые палитры, шрифты, руководства по стилю или другие активы бренда',
        brandAssetsDesc: 'Введите один URL на строку',
        constraints: 'Ограничения и ограничения',
        constraintsPlaceholder: 'Вещи, которых следует избегать, ограничения, юридические требования, обязательные элементы (логотипы, отказ от ответственности) или любые ограничения',
        budget: 'Бюджет',
        budgetPlaceholder: 'например, $10,000 - $15,000 или диапазон бюджета',
        deadline: 'Срок',
        deadlineRequired: 'Срок *',
        approvalContactName: 'Имя контактного лица для одобрения',
        approvalContactNameRequired: 'Имя контактного лица для одобрения *',
        approvalContactEmail: 'Email контактного лица для одобрения',
        approvalContactEmailRequired: 'Email контактного лица для одобрения *',
        additionalNotes: 'Дополнительные примечания',
        additionalNotesPlaceholder: 'Любая дополнительная информация, контекст или специальные инструкции для творческой команды',
        submit: 'Отправить бриф',
        submitting: 'Отправка...',
        cancel: 'Отмена',
        eventInfo: 'Информация о событии (Необязательно)',
        eventInfoDesc: 'Заполните этот раздел, если ваш бриф касается события',
        numberOfParticipants: 'Общее количество участников',
        numberOfParticipantsPlaceholder: 'Автоматически рассчитывается из всех мест',
        totalParticipants: 'Всего участников',
        totalParticipantsDesc: 'Сумма участников из всех мест',
        eventLocations: 'Места проведения события',
        eventLocationsDesc: 'Добавьте одно или несколько мест с деталями для каждого',
        location: 'Место',
        country: 'Страна',
        selectCountry: 'Выберите страну',
        address: 'Адрес',
        addressPlaceholder: 'Полный адрес',
        dateStart: 'Дата начала',
        dateEnd: 'Дата окончания',
        timeStart: 'Время начала',
        timeEnd: 'Время окончания',
        participantsPerLocation: 'Количество участников',
        addLocation: 'Добавить другое место',
        eventDate: 'Дата события (Необязательно)',
        eventTime: 'Время события (Необязательно)',
        eventTimeDesc: 'Время дня для события',
        sections: {
          campaignBasics: 'Основы кампании (Цель, Заголовок)',
          targetAudience: 'Целевая аудитория',
          messaging: 'Сообщения (Ключевое сообщение, Тон, Реакция)',
          deliverables: 'Результаты и каналы',
          eventInfo: 'Информация о событии',
          digitalMarketing: 'Цифровой маркетинг',
          printMaterials: 'Печатные материалы',
          inspiration: 'URL вдохновения',
          brandAssets: 'Активы бренда и руководящие принципы',
          constraints: 'Ограничения и ограничения',
          budget: 'Бюджет',
          contact: 'Контактная информация',
          notes: 'Дополнительные примечания',
        },
        specifyOther: 'Указать другое',
        allFieldsRequired: 'Пожалуйста, заполните все обязательные поля',
        eventFieldsRequired: 'Пожалуйста, заполните поля, специфичные для события (количество участников и хотя бы одно место)',
        selectBriefType: 'Пожалуйста, выберите тип брифа',
      },
      fields: {
        objective: 'Цель',
        targetAudience: 'Целевая аудитория',
        desiredReaction: 'Желаемая реакция',
        keyMessage: 'Ключевое сообщение',
        tone: 'Тон',
        deliverables: 'Результаты',
        deadline: 'Срок',
        approvalContactName: 'Имя контактного лица для одобрения',
        approvalContactEmail: 'Email контактного лица для одобрения',
        campaignTitle: 'Название кампании',
        inspirationUrls: 'URL вдохновения',
        brandAssets: 'Активы бренда',
        constraints: 'Ограничения',
        budget: 'Бюджет',
        additionalNotes: 'Дополнительные примечания',
      },
      statuses: {
        submitted: 'Отправлен',
        inReview: 'На рассмотрении',
        approved: 'Одобрен',
        inProgress: 'В процессе',
        completed: 'Завершен',
        rejected: 'Отклонен',
      },
    },
    manager: {
      title: 'Менеджеры проектов',
      add: 'Добавить менеджера',
      edit: 'Редактировать менеджера',
      delete: 'Удалить менеджера',
      name: 'Имя',
      email: 'Email',
      phone: 'Телефон',
      username: 'Имя пользователя',
      password: 'Пароль',
      isActive: 'Активен',
      briefCount: 'брифов',
      cannotDelete: 'Нельзя удалить: есть назначенные брифы',
      deleteConfirm: 'Вы уверены, что хотите удалить',
    },
    user: {
      title: 'Пользователи',
      username: 'Имя пользователя',
      email: 'Email',
      companyName: 'Название компании',
      role: 'Роль',
      delete: 'Удалить',
      deleteConfirm: 'Вы уверены, что хотите удалить',
    },
  },
  zh: {
    nav: {
      title: '简报 613',
      welcome: '欢迎，',
      logout: '登出',
      managerLogin: '管理员登录',
    },
    login: {
      title: '登录',
      subtitle: '欢迎回到简报 613',
      username: '用户名或邮箱',
      password: '密码',
      usernamePlaceholder: '输入您的用户名或邮箱',
      passwordPlaceholder: '输入您的密码',
      loginButton: '登录',
      loggingIn: '登录中...',
      noAccount: '没有账户？',
      register: '注册',
      error: '发生错误',
      invalidCredentials: '用户名或密码无效',
      required: '需要用户名和密码',
    },
    register: {
      title: '注册',
      subtitle: '创建您的简报 613 账户',
      username: '用户名',
      email: '邮箱',
      password: '密码',
      confirmPassword: '确认密码',
      companyName: '公司名称',
      usernamePlaceholder: '输入您的用户名',
      emailPlaceholder: '输入您的邮箱',
      passwordPlaceholder: '输入您的密码',
      confirmPasswordPlaceholder: '确认您的密码',
      companyNamePlaceholder: '输入您的公司名称',
      registerButton: '注册',
      registering: '注册中...',
      haveAccount: '已有账户？',
      login: '登录',
      allFieldsRequired: '所有字段都是必需的',
      passwordTooShort: '密码必须至少 6 个字符',
      passwordsDontMatch: '密码不匹配',
      error: '发生错误',
    },
    managerLogin: {
      title: '管理员登录',
      subtitle: '访问您的管理员仪表板',
      username: '用户名',
      password: '密码',
      usernamePlaceholder: '输入您的用户名',
      passwordPlaceholder: '输入您的密码',
      loginButton: '登录',
      loggingIn: '登录中...',
      error: '发生错误',
      invalidCredentials: '用户名或密码无效',
    },
    common: {
      loading: '加载中...',
      error: '错误',
      success: '成功',
      cancel: '取消',
      save: '保存',
      delete: '删除',
      edit: '编辑',
      add: '添加',
      close: '关闭',
      confirm: '确认',
      yes: '是',
      no: '否',
      search: '搜索',
      filter: '筛选',
      actions: '操作',
    },
    dashboard: {
      client: {
        title: '客户仪表板',
        createBrief: '创建简报',
        myBriefs: '我的简报',
        noBriefs: '还没有简报',
        createFirstBrief: '创建您的第一个简报',
      },
      admin: {
        title: '管理员仪表板',
        briefs: '简报',
        users: '用户',
        managers: '管理员',
        notifications: '通知',
      },
      manager: {
        title: '管理员仪表板',
        assignedBriefs: '分配的简报',
        noBriefs: '没有分配的简报',
      },
    },
    brief: {
      create: '创建简报',
      edit: '编辑简报',
      view: '查看简报',
      delete: '删除简报',
      title: '简报标题',
      status: '状态',
      manager: '管理员',
      createdAt: '创建于',
      updatedAt: '更新于',
      form: {
        title: '创建创意简报',
        selectType: '选择简报类型',
        selectTypeDesc: '选择您要创建的简报类型',
        changeType: '更改类型',
        briefType: '简报类型',
        event: '活动',
        digitalMarketing: '数字营销活动',
        print: '印刷',
        custom: '自定义',
        eventDesc: '用于活动策划、会议、研讨会和实体聚会。包括活动特定字段，如地点、日期和参与者数量。',
        digitalDesc: '用于在线活动、社交媒体、网站、数字广告和在线内容。专注于数字渠道和平台。',
        printDesc: '用于印刷材料、宣传册、海报、包装、销售点材料和其他实体印刷品。',
        customDesc: '用于混合活动或需要所有内容时。根据您的需求从活动、数字营销和印刷中选择要包含的部分。',
        selectSections: '选择要包含的部分',
        selectSectionsDesc: '选择您想在简报中包含的部分',
        campaignTitle: '活动名称 / 标题',
        campaignTitlePlaceholder: '例如：2024年夏季产品发布',
        objective: '目标',
        objectiveRequired: '目标 *',
        targetAudience: '目标受众',
        targetAudienceRequired: '目标受众 *',
        targetAudiencePlaceholder: '这次活动的主要受众是谁？',
        desiredReaction: '期望的反应',
        desiredReactionRequired: '期望的反应 *',
        selectReaction: '选择反应',
        keyMessage: '关键信息',
        keyMessageRequired: '关键信息 *',
        keyMessagePlaceholder: '您想要传达的一个关键信息是什么？',
        tone: '语调或风格',
        toneRequired: '语调或风格 *',
        selectTone: '选择语调',
        deliverables: '交付物和渠道',
        deliverablesRequired: '交付物和渠道 *',
        addUrl: '添加链接',
        inspirationUrls: '灵感链接',
        inspirationUrlsDesc: '添加用于灵感、参考活动或示例的链接',
        brandAssets: '品牌资产和指南',
        brandAssetsPlaceholder: '品牌指南、标志、调色板、字体、风格指南或其他品牌资产的链接',
        brandAssetsDesc: '每行输入一个链接',
        constraints: '约束和限制',
        constraintsPlaceholder: '要避免的事项、限制、法律要求、强制性元素（标志、免责声明）或任何限制',
        budget: '预算',
        budgetPlaceholder: '例如：$10,000 - $15,000 或预算范围',
        deadline: '截止日期',
        deadlineRequired: '截止日期 *',
        approvalContactName: '审批联系人姓名',
        approvalContactNameRequired: '审批联系人姓名 *',
        approvalContactEmail: '审批联系人邮箱',
        approvalContactEmailRequired: '审批联系人邮箱 *',
        additionalNotes: '附加说明',
        additionalNotesPlaceholder: '任何附加信息、上下文或给创意团队的特殊说明',
        submit: '提交简报',
        submitting: '提交中...',
        cancel: '取消',
        eventInfo: '活动信息（可选）',
        eventInfoDesc: '如果您的简报是关于活动的，请填写此部分',
        numberOfParticipants: '参与者总数',
        numberOfParticipantsPlaceholder: '从所有地点自动计算',
        totalParticipants: '总参与者',
        totalParticipantsDesc: '所有地点的参与者总和',
        eventLocations: '活动地点',
        eventLocationsDesc: '添加一个或多个地点，每个地点包含详细信息',
        location: '地点',
        country: '国家',
        selectCountry: '选择国家',
        address: '地址',
        addressPlaceholder: '完整地址',
        dateStart: '开始日期',
        dateEnd: '结束日期',
        timeStart: '开始时间',
        timeEnd: '结束时间',
        participantsPerLocation: '参与者数量',
        addLocation: '添加另一个地点',
        eventDate: '活动日期（可选）',
        eventTime: '活动时间（可选）',
        eventTimeDesc: '活动的具体时间',
        sections: {
          campaignBasics: '活动基础（目标、标题）',
          targetAudience: '目标受众',
          messaging: '信息（关键信息、语调、反应）',
          deliverables: '交付物和渠道',
          eventInfo: '活动信息',
          digitalMarketing: '数字营销特定',
          printMaterials: '印刷材料',
          inspiration: '灵感链接',
          brandAssets: '品牌资产和指南',
          constraints: '约束和限制',
          budget: '预算',
          contact: '联系信息',
          notes: '附加说明',
        },
        specifyOther: '指定其他',
        allFieldsRequired: '请填写所有必填字段',
        eventFieldsRequired: '请填写活动特定必填字段（参与者数量和至少一个地点）',
        selectBriefType: '请选择简报类型',
      },
      fields: {
        objective: '目标',
        targetAudience: '目标受众',
        desiredReaction: '期望的反应',
        keyMessage: '关键信息',
        tone: '语调',
        deliverables: '交付物',
        deadline: '截止日期',
        approvalContactName: '审批联系人姓名',
        approvalContactEmail: '审批联系人邮箱',
        campaignTitle: '活动标题',
        inspirationUrls: '灵感链接',
        brandAssets: '品牌资产',
        constraints: '约束',
        budget: '预算',
        additionalNotes: '附加说明',
      },
      statuses: {
        submitted: '已提交',
        inReview: '审核中',
        approved: '已批准',
        inProgress: '进行中',
        completed: '已完成',
        rejected: '已拒绝',
      },
    },
    manager: {
      title: '项目经理',
      add: '添加管理员',
      edit: '编辑管理员',
      delete: '删除管理员',
      name: '姓名',
      email: '邮箱',
      phone: '电话',
      username: '用户名',
      password: '密码',
      isActive: '活跃',
      briefCount: '简报',
      cannotDelete: '无法删除：有分配的简报',
      deleteConfirm: '您确定要删除',
    },
    user: {
      title: '用户',
      username: '用户名',
      email: '邮箱',
      companyName: '公司名称',
      role: '角色',
      delete: '删除',
      deleteConfirm: '您确定要删除',
    },
  },
}

export function getBrief613Translation(lang: Language): Brief613Translations {
  return brief613Translations[lang] || brief613Translations.en
}

